var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container pre-enrollment--content",class:{ 'content--client-page': _vm.isClientPage }},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }